import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSecurityLock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#9575CD' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M12.5 15.5V14c0-2.482.75-4.5 4.5-4.5s4.5 2.018 4.5 4.5v1.5M20.75 24.5h-7.5c-3 0-3.75-.75-3.75-3.75v-1.5c0-3 .75-3.75 3.75-3.75h7.5c3 0 3.75.75 3.75 3.75v1.5c0 3-.75 3.75-3.75 3.75M19.998 20h.007'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M16.997 20h.007M13.996 20h.007'
    />
  </svg>
);
export default SvgSecurityLock;
